export function customQuantityFieldsScript() {
    function updateMiniCart(cart_item_key, newQuantity, $qty) {
      setMiniCartLoader(true);
      fetch(
        `${ajax.url}?action=set_product_quantity&cart_item_key=${cart_item_key}&quantity=${newQuantity}`
      )
        .then((result) => result.json())
        .then((result) => {
          $qty.val(newQuantity);
          updateMiniCartCount(cart_item_key, result.quantity);
          updateMiniCartTotal(result.total);
          updateMiniCartDiscount(result.discount);
          setMiniCartLoader(false);
        })
        .catch((error) => {
          console.error(error);
          setMiniCartLoader(false);
        });
    }
    function setMiniCartLoader(state) {
      const loaders = document.querySelectorAll(
        ".headerDesktop__topBarColumn--miniCart"
      );
      if (state === true) { // display: grid;
        for (const loader of loaders) {
          loader.classList.add("loading");
        }
      } else {
        for (const loader of loaders) {
          loader.classList.remove("loading");
        }
      }
    }
    function updateMiniCartTotal(total) {
      const totalNodes = document.querySelectorAll(".total .amount");
      for (const totalNode of totalNodes) {
        totalNode.innerHTML = totalNode.innerHTML.replace(/^(\d|\s)+,\d+/, total);
      }
    }
    function updateMiniCartDiscount(discount) {
      const discountNodes = document.querySelectorAll(".total .discount");
      for (const discountNode of discountNodes) {
        discountNode.innerHTML = discountNode.innerHTML.replace(
          /^(\d|\s)+,\d+/,
          discount
        );
      }
    }
    function updateMiniCartCount(id, count) {
      let totalCount = 0;
      const miniCart = document.querySelector(".woocommerce-mini-cart");
      const quantities = miniCart.querySelectorAll(".miniCart__single .qty");
      for (const quantity of quantities) {
        totalCount += Number(quantity.value);
      }
  
      const productCountNodes = document.querySelectorAll(
        `.miniCart__single[data-cart_item_key="${id}"] span.quantity`
      );
      for (const productCount of productCountNodes) {
        productCount.innerHTML = productCount.innerHTML.replace(/\d+/, count);
      }
      const cartTotalCountNodes = document.querySelectorAll(
        ".menuShopButtons__cart-count"
      );
      for (const cartTotalCount of cartTotalCountNodes) {
        cartTotalCount.textContent = totalCount;
      }
    }
  
    jQuery(function ($) {
      if (!String.prototype.getDecimals) {
        String.prototype.getDecimals = function () {
          var num = this,
            match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
          if (!match) {
            return 0;
          }
          return Math.max(
            0,
            (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
          );
        };
      }
      // Quantity "plus" and "minus" buttons
      $(document.body).on("click", ".plus, .minus", function () {
        var $qty = $(this).closest(".quantity").find(".qty"),
          currentVal = parseFloat($qty.val()),
          max = parseFloat($qty.attr("max")),
          min = parseFloat($qty.attr("min")),
          step = $qty.attr("step");
  
        // Format values
        if (!currentVal || currentVal === "" || currentVal === "NaN")
          currentVal = 0;
        if (max === "" || max === "NaN") max = "";
        if (min === "" || min === "NaN") min = 0;
        if (
          step === "any" ||
          step === "" ||
          step === undefined ||
          parseFloat(step) === "NaN"
        )
          step = 1;
  
        // Change the value
        if ($(this).is(".plus")) {
          if (max && currentVal >= max) {
            $qty.val(max);
          } else {
            const newQuantity = (currentVal + parseFloat(step)).toFixed(
              step.getDecimals()
            );
            const cart_item_key = $(this)
              .closest(".miniCart__single")
              .data("cart_item_key");
            if (cart_item_key !== undefined) {
              updateMiniCart(cart_item_key, newQuantity, $qty);
            } else {
              $qty.val(newQuantity);
            }
          }
        } else {
          if (min && currentVal <= min) {
            $qty.val(min);
          } else if (currentVal > 0) {
            const newQuantity = (currentVal - parseFloat(step)).toFixed(
              step.getDecimals()
            );
            const cart_item_key = $(this)
              .closest(".miniCart__single")
              .data("cart_item_key");
            if (cart_item_key !== undefined) {
              updateMiniCart(cart_item_key, newQuantity, $qty);
            } else {
              $qty.val(newQuantity);
            }
          }
        }
  
        // Trigger change event
        $qty.trigger("change");
      });
    });
  }
  